import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { TextTestIDs, TextStyle } from '@kui-shared/text';
import { CommonModule } from '@angular/common';

class TextDirective {
    get testId() {
        return TextTestIDs.Text;
    }
    get className() {
        return this._textStyle;
    }
    ngOnInit() {
        this._updateStyle();
    }
    ngOnChanges() {
        this._updateStyle();
    }
    _updateStyle() {
        this._textStyle = TextStyle({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            as: String(this._element.nativeElement.tagName).toLowerCase(),
            css: this.css,
            variant: this.variant,
        }).className;
    }
    constructor(_element) {
        this._element = _element;
        this._textStyle = '';
    }
}
TextDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: TextDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TextDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.1.4", type: TextDirective, selector: "[kuiText]", inputs: { css: "css", variant: "variant" }, host: { properties: { "attr.data-testid": "this.testId", "class": "this.className" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: TextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[kuiText]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { testId: [{
                type: HostBinding,
                args: ['attr.data-testid']
            }], className: [{
                type: HostBinding,
                args: ['class']
            }], css: [{
                type: Input
            }], variant: [{
                type: Input
            }] } });

class TextModule {
}
TextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: TextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.1.4", ngImport: i0, type: TextModule, declarations: [TextDirective], imports: [CommonModule], exports: [TextDirective] });
TextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: TextModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: TextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TextDirective],
                    imports: [CommonModule],
                    exports: [TextDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TextDirective, TextModule };
